import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-yes-no-modal',
  templateUrl: './yes-no-modal.component.html',
  styleUrls: ['./yes-no-modal.component.scss']
})
export class YesNoModalComponent implements OnInit {

  title = "";
  errorMessage = "";
  constructor(private  dialogRef:  MatDialogRef<YesNoModalComponent>, @Inject(MAT_DIALOG_DATA) public  data:  any) {
    this.title = data?.title;
    this.errorMessage = data?.message;
  }
  public  closeMe(status: any) {
      this.dialogRef.close({ data: status });
  }

  ngOnInit(): void {
  }

}
